import React, { useState, useEffect } from "react"
import CurrencyFormat from "react-currency-format";
import { encodeStorage } from 'functions/storageBase64';
import { dateFormat } from 'functions/dateFormat'

export function useConsultaSaldoData(dataConsultaSaldo){
    const [monto, setMonto] = useState('0.00')
    const [mensualidad, setMensualidad] = useState('0.00')
    const [minimo, setMinimo] = useState('0.00')
    const [saldoNuevoCorte, setSaldoNuevoCorte] = useState('0.00')
    const [pagoNoGenerarIntereses, setPagoNoGenerarIntereses] = useState('0.00')
    const [limiteCredito, setLimiteCredito] = useState('0.00')
    const [fechaLimite, setFechaLimite] = useState( dateFormat( '1210101') )
    const [fechaCorte, setFechaCorte] = useState( dateFormat( '1210101') )
    const [nombreTitular, setNombreTitular] = useState()
    const [cardending, setCardending] = useState('0000')
    const [status, setStatus] = useState(false)
    const [noInternet, setNoInternet] = useState(false)

    const [cardsService, setCardsService ] = useState()
    useEffect(()=>{
        if(dataConsultaSaldo){
            const arrayConsultaSaldo = [dataConsultaSaldo]
            encodeStorage('lastConsultData', arrayConsultaSaldo)
            setCardsService(arrayConsultaSaldo)
        }
    },[dataConsultaSaldo])

    const [selectCard, setSelectCard ] = useState()
    const [loading, setLoading] = useState(true)
    useEffect(()=>{
        if(cardsService){
            setLoading(true)
            if(cardsService?.length >= 1){
                setSelectCard(true)
            }
        }
    },[cardsService])

    
    useEffect(()=>{
        if(selectCard){
            setMonto(cardsService[0]?.credit_available)
            setMensualidad(cardsService[0]?.monthly_payment)
            setMinimo(cardsService[0]?.minimum_to_pay)
            setSaldoNuevoCorte(cardsService[0]?.new_balance_cutting)
            setPagoNoGenerarIntereses(cardsService[0]?.payment_not_generate_interest)
            setLimiteCredito(cardsService[0]?.credit_imit)
            setStatus(cardsService[0]?.status_app)
            setNoInternet(cardsService[0]?.noInternet)
            if(cardsService[0]?.payday_limit){
                setFechaLimite( dateFormat(cardsService[0]?.payday_limit) )
            }
            if(cardsService[0]?.bill_date){
                setFechaCorte( dateFormat(cardsService[0]?.bill_date) )
            }
            if(cardsService[0]?.name){
                setNombreTitular(cardsService[0]?.name+' '+cardsService[0]?.paternal+' '+cardsService[0]?.maternal)
                encodeStorage('nombreTitular', cardsService[0]?.name+' '+cardsService[0]?.paternal+' '+cardsService[0]?.maternal)
            }
            if(cardsService[0]?.email){
                encodeStorage('email', cardsService[0]?.email.toLowerCase())
            }
            if(cardsService[0]?.cards){
                setCardending(cardsService[0]?.cards[0]?.card_number.slice(-4))
                encodeStorage('cardending',cardsService[0]?.cards[0]?.card_number.slice(-4))
            }
            setLoading(false)
        }
    },[selectCard, cardsService])

    let numeroTarjeta = "** **** *" + cardending
    let titulo = "Crédito SEARS *" + cardending

    let saldoDisponible = <CurrencyFormat
        value={Number(monto % 1) === 0 ? monto + '.001' : monto}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>}
    />;

    let montoMensualidad = <CurrencyFormat
        value={Number(mensualidad % 1) === 0 ? mensualidad + '.001' : mensualidad}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoMinimo = <CurrencyFormat
        value={Number(minimo % 1) === 0 ? minimo + '.001' : minimo}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoNuevoCorte = <CurrencyFormat
        value={Number(saldoNuevoCorte % 1) === 0 ? saldoNuevoCorte + '.001' : saldoNuevoCorte}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoPagoNoGenerarIntereses = <CurrencyFormat
        value={Number(pagoNoGenerarIntereses % 1) === 0 ? pagoNoGenerarIntereses + '.001' : pagoNoGenerarIntereses}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let montoLimiteCredito = <CurrencyFormat
        value={Number(limiteCredito % 1) === 0 ? limiteCredito + '.001' : limiteCredito}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    let saldoBtnActive = saldoNuevoCorte
   
    const dataSaldos = {
        numeroTarjeta,
        saldoDisponible,
        montoMensualidad,
        montoMinimo,
        montoNuevoCorte,
        montoPagoNoGenerarIntereses,
        montoLimiteCredito,
        fechaLimite,
        fechaCorte,
        nombreTitular,
        titulo,
        cardending,
        status,
        noInternet,
        saldoBtnActive
    }
    const upDateDataSaldos = updateDataCard => setCardsService(updateDataCard)
        
    return {
        dataSaldos,
        loading,
        upDateDataSaldos
    }
}